import { Component } from '@angular/core';
import { CoverpathUtilsFrontEnd } from '../../../../js/static/CoverpathUtilsFrontEnd';
import { AccountCenterSection } from './accountCenterSection.component';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { CoverpathBaseAccountCenterController } from '../../../../js/controllers/CoverpathBaseAccountCenterController';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import type { CasApplication } from '../../../../classes/coverpath_subclasses/CasApplication';
import { MMDirectApplication } from '../../../../classes/mmdirect_subclasses/MMDirectApplication';

@Component({
  selector: 'account-center-template',
  moduleId: module.id,
  templateUrl: './account-center-template.component.html',
})
export class AccountCenterTemplateComponent extends AccountCenterSection {
  //Used in corresponding html template to show life vs annuity details
  isAnnuity: boolean;
  showAdvisorLinks: boolean;
  showDocuSignCoin: boolean = false;
  application: CasApplication | MMDirectApplication;
  accountCenterController: CoverpathBaseAccountCenterController;

  constructor(accountCenterService: AccountCenterService, amorphicService: AmorphicService) {
    super(amorphicService, accountCenterService);
    this.accountCenterController = amorphicService.controller.accountCenterController;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isAnnuity = this.accountCenterService.application.primaryPolicy.isAnnuity();
    this.application = this.amorphicService.controller.customer.application;
    this.showDocuSignCoin = this.getPendingDocusignCoin();
    this.showAdvisorLinks = this.accountCenterService.application.primaryPolicy.primaryPolicyAgent ? true : false;
  }

  getPendingDocusignCoin(): boolean {
    const inDocuSignStage = /Waiting for Signature/.test(this.application.primaryPolicy.getWorkflowAction());
    const isDocuSignRedirectEnabled = this.amorphicService.controller.isDocuSignRedirectEnabled;
    const nonProdMode = this.amorphicService.controller.nonProdMode;
    return CoverpathUtilsFrontEnd.getPendingDocusignCoin(
      this.application,
      isDocuSignRedirectEnabled,
      inDocuSignStage,
      nonProdMode
    );
  }

  async retrieveDocusignDocumentsLocal(): Promise<void> {
    this.accountCenterController.submitDocusignNotifyLocal(this.application.primaryPolicy);
  }
}
